var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-item",class:_vm.icon ? 'has-icon' : '',on:{"click":_vm.handleClickItem}},[_c('div',{staticClass:"icon"},[_c('svg-render',{attrs:{"name":_vm.icon}})],1),_c('div',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }